<template>

        <v-container fluid class="main-body">
            <r-header></r-header>
            <v-row
                    class="login-form"
                    align="center"
                    justify="center"
            >
                <v-col
                        cols="12"
                        sm="8"
                        md="6"
                >
                    <v-card class="elevation-12">
                        <v-toolbar
                                color="orange"
                                dark
                                flat
                        >
                            <v-toolbar-title>Por favor, introduzca sus datos de acceso</v-toolbar-title>
                            <v-spacer />
                        </v-toolbar>
                        <v-card-text>
                            <v-form>
                                <v-text-field
                                        label="Usuario"
                                        name="usuario"
                                        prepend-icon="person"
                                        type="text"
                                        v-model.trim="usuario"
                                />

                                <v-text-field
                                        id="password"
                                        label="Password"
                                        name="password"
                                        prepend-icon="lock"
                                        type="password"
                                        v-model.trim="password"
                                />
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn color="primary" @click="setCookie">Entrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <Footer></Footer>
        </v-container>

</template>

<script>
    import { cookiesHelper } from "../../_helpers";
    import {panelService} from "../../_services/panel";
    import RHeader from "../../components/shared/HeaderComponent";
    import Footer from "../../components/shared/Footer";

    export default {
        name: "Login",
        components: {Footer, RHeader},
        data() {
            return {
                usuario:'',
                password:''
            }
        },
        methods: {
            setCookie() {
                panelService.getToken( { usuario: this.usuario, password: this.password}).then( res => {
                    if(res.status == 201) {
                        cookiesHelper.setCookie(res.data.access_token, res.data.expires_in)
                        this.$router.push('panel')
                    }
                }).catch( (err) => {
                    //eslint-disable-next-line
                    console.log(err)
                } )

            }
        }
    }
</script>

<style scoped lang="scss">
    @import "./../../_static/base";
    .login-form {
        margin: 1rem auto;
    }
</style>